import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import {
    setPlayerRecomendationFirstTimeFalse,
    showHidePlayerRecomendationPopUp,
    showPlayerRecomMobPopUp
} from './../../../actions/FormationActions';
import config from '../../../config';
import common from '../../../common';
import PlayerRecomendationPopUp from './PlayerRecomendationPopUp'
import OutsideNotifier from '../../../OutsideNotifier';

class PlayerRecomendation extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showRecomendationPopUp: false
        }
    }

    componentDidUpdate() {

    }

    onRecomendationPopUpClose = () => {
        this.setState({
            showRecomendationPopUp: false
        })
    }



    showPopUp = () => {

        common.customTracking('Select Player Recommendations Filter - Player List', common.getPageName());
        // show firsrt time pop up 
        if (this.props.IsFirstTimeRecomend) {
            //show Pop Up
            common.setLocalStorage('IsFirstTimeRecomend', false);
            this.props.setPlayerRecomendationFirstTimeFalse(false);
            this.props.showHidePlayerRecomendationPopUp(true);
            // common.customTracking('Select Player Recomendation Filter - Filter');
        } else {
            //show drop down
            this.props.showPlayerRecomMobPopUp(true);
            // common.customTracking('Select Player Recomendation Filter - Filter');
        }
    }

    render() {
        return <React.Fragment> <div className="si-filter-items " onClick={ () => { this.showPopUp() } }>
            <div className="si-filter-item-wrap si-suggest-icon">
                <i className="icon-ucl-new-filter si-filter-icons"></i>
                { this.props.IsFirstTimeRecomend ? <span className="si-suggest-new si-flexBox">{ this.props.trans.new ? this.props.trans.new : "new" }</span> : null }
            </div>
            <div className="si-tooltip">
                <span>tooltips</span>
            </div>

        </div>

        </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        playerRecomendation: state.formationData.playerRecomendation,
        IsFirstTimeRecomend: state.formationData.IsFirstTimeRecomend,
        playerRecomendationKeys: state.formationData.playerRecomendationKeys
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setPlayerRecomendationFirstTimeFalse: () => dispatch(setPlayerRecomendationFirstTimeFalse()),
        showHidePlayerRecomendationPopUp: (bool) => dispatch(showHidePlayerRecomendationPopUp(bool)),
        showPlayerRecomMobPopUp: (bool) => dispatch(showPlayerRecomMobPopUp(bool))
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerRecomendation);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PlayerRecomendation.js